/**
 * Game loop: requestAnimationFrame → Tick(deltaMs) (ADR-5).
 */

export interface GameLoopOptions {
  tick(deltaMs: number): void;
}

export function createGameLoop(options: GameLoopOptions) {
  let rafId: number | null = null;
  let lastTime: number | null = null;
  let disposed = false;

  function loop(now: number) {
    if (disposed) return;
    const delta = lastTime !== null ? now - lastTime : 0;
    lastTime = now;
    options.tick(delta);
    rafId = requestAnimationFrame(loop);
  }

  return {
    start() {
      if (disposed || rafId !== null) return;
      lastTime = null;
      rafId = requestAnimationFrame(loop);
    },
    stop() {
      if (rafId !== null) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }
      lastTime = null;
    },
    dispose() {
      disposed = true;
      if (rafId !== null) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }
      lastTime = null;
    },
  };
}
